import React from 'react';
import { Box } from '@mui/material';
import { useDestrierTheme } from '../ThemeContext';

const PERIODS = [
  { key: 'week', label: 'Last Week' },
  { key: '6months', label: '6 Months' },
  { key: 'year', label: 'Last Year' },
  { key: 'all', label: 'All Time' },
];

export default function TimePeriodFilter({ value = 'all', onChange }) {
  const { c } = useDestrierTheme();

  return (
    <Box sx={{
      display: 'inline-flex',
      gap: 0.75,
      p: 0.75,
      borderRadius: '999px',
      backgroundColor: `${c.cardBg || '#252530'}e6`,
      border: `1px solid ${c.cardBorder || '#8b95a815'}`,
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
    }}>
      {PERIODS.map(({ key, label }) => {
        const isActive = value === key;
        return (
          <Box
            key={key}
            onClick={() => onChange(key)}
            sx={{
              px: { xs: 2, sm: 2.8 },
              py: { xs: 0.8, sm: 1 },
              borderRadius: '999px',
              fontSize: { xs: '0.82rem', sm: '0.95rem' },
              fontWeight: isActive ? 700 : 500,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              color: isActive ? '#fff' : (c.textMuted || '#8b95a8'),
              backgroundColor: isActive ? (c.accent || '#8F7BE0') : 'transparent',
              transition: 'all 0.15s ease',
              '&:hover': {
                backgroundColor: isActive
                  ? (c.accent || '#8F7BE0')
                  : `${c.textMuted || '#8b95a8'}15`,
              },
            }}
          >
            {label}
          </Box>
        );
      })}
    </Box>
  );
}
